/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CreditUsageResponseBody = {
  /**
   * The number of credits remaining
   */
  creditsUsed: number;
  /**
   * The number of monthly credits
   */
  monthlyCredits: number;
};

/** @internal */
export const CreditUsageResponseBody$inboundSchema: z.ZodMiniType<
  CreditUsageResponseBody,
  unknown
> = z.pipe(
  z.object({
    credits_used: z.number(),
    monthly_credits: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "credits_used": "creditsUsed",
      "monthly_credits": "monthlyCredits",
    });
  }),
);

export function creditUsageResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<CreditUsageResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreditUsageResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreditUsageResponseBody' from JSON`,
  );
}
